import { useEffect, useState } from "react";
import { UserRound } from "lucide-react";
import { PageHeader } from "@/components/AdminLayout";
import { api } from "@/lib/api";
import { TAB_LABELS } from "@/lib/i18n";

export default function Team() {
  const [list, setList] = useState(null);
  useEffect(() => { api.get("/team").then((r) => setList(r.data)); }, []);
  return (
    <>
      <PageHeader title="Mi equipo" subtitle="Cajeros asignados a tu grupo. Solo el administrador puede modificarlos." />
      <div className="divide-y divide-slate-100 overflow-hidden rounded-2xl border border-slate-200 bg-white" data-testid="team-list">
        {list && !list.length && <p className="px-5 py-8 text-center text-sm text-slate-400" data-testid="team-empty">Aún no tienes cajeros asignados.</p>}
        {(list || []).map((u) => (
          <div key={u.id} className="flex items-center gap-3 px-5 py-4" data-testid={`team-row-${u.id}`}>
            <span className="grid h-9 w-9 place-items-center rounded-full bg-slate-100 text-slate-500"><UserRound size={16} /></span>
            <div className="flex-1">
              <p className="font-semibold text-slate-900">{u.name}</p>
              <p className="text-sm text-slate-500">{u.email}</p>
            </div>
            <span className="hidden text-xs text-slate-500 sm:block">{u.permissions.map((p) => TAB_LABELS[p]).join(" · ") || "Sin pestañas"}</span>
            <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${u.active ? "bg-emerald-50 text-emerald-700" : "bg-slate-100 text-slate-500"}`}>{u.active ? "Activo" : "Inactivo"}</span>
          </div>
        ))}
      </div>
    </>
  );
}
